import { Theme } from "@mui/material";
import { IFormRadioGroup } from "../../../services/custom-forms-data-service/TemplateModels";
import FormProperty from "../../forms/form-property/FormProperty";
import FormRadioGroup from "../../forms/form-radio-group/FormRadioGroup";
import { SxProps } from "@mui/system";

export type CustomFormRadioGroupProps = {
    radioButtonGroup: IFormRadioGroup;
    key?: React.Key | null | undefined;
    sx?: SxProps<Theme>;
};


export default function CustomFormRadioGroup({
    radioButtonGroup,
    key,
    sx
}: CustomFormRadioGroupProps) {

     return (

        <FormProperty key={key} sx={sx}>
            <FormRadioGroup
                name={radioButtonGroup.name}
                ariaLabel={radioButtonGroup.ariaLabel}
                label={radioButtonGroup.label}
                helperText={radioButtonGroup.helperText}
                radioButtons={radioButtonGroup.radioButtons}
                readOnly={radioButtonGroup.readOnly}
            />
        </FormProperty>
    );
}
